<template>
        <span 
            class="inline-flex items-center px-3 rounded-full leading-4 tag text-white"
            :class="'bg-salesium-blue'"
            @click="activateTagFilter"
        >
            {{tag.name}}
            <svg-vue v-if="isActive" icon="circle-check-solid" title="checked" :fill="'white'" class="w-4 h-4 inline-block ml-3" />
        </span>
</template>

<script>
export default {
    props: ['tag'],
    data(){
        return{
            isActive: false,
        }
    },
    methods:{
        activateTagFilter(){
            this.isActive = !this.isActive;
            this.$emit('tagClicked', this.tag.name);
        }
    }
}
</script>

<style scoped>
    .tag{
        cursor: pointer;
        height: 30px;
        margin-bottom: 20px;
        margin-right: 20px;
    }
</style>